<script setup lang="ts">
import { provide, shallowRef, watch } from 'vue';
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import MarketplaceExecutionsTable from '@/modules/marketplace/components/MarketplaceExecutionsTable.vue';
import { CompanyInfo } from '@/modules/common/models';
import BrokerCompanySelector from '@/modules/broker-admin/views/BrokerCompanySelector.vue';
import { useAgreementsStore } from '@/store/agreements-store';

provide('gridStateKey', 'BrokerMarketplaceExecutionsView');

const selectedCompany = shallowRef<CompanyInfo | null>(null);
watch(selectedCompany, async () => {
  if (selectedCompany.value)
    await useAgreementsStore().loadAgreements(selectedCompany.value?.companyId);
});
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex gap-1">
        <BrokerCompanySelector v-model="selectedCompany" class="company-selector" />
      </div>
    </div>
    <DashboardPanel no-collapse title="Executions">
      <VCard class="flex d-flex flex-column">
        <MarketplaceExecutionsTable as-broker :company-id-filter="selectedCompany?.companyId" />
      </VCard>
    </DashboardPanel>
  </div>
</template>

<style lang="scss">
.company-selector {
  width: 325px;
}
</style>
